module.exports = __webpack_public_path__ + "static/img/img_logo.8603340c.png";